import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";

import { LoadingProductTileSkeleton } from "@faire/retailer/components/LoadingProductTileSkeleton/LoadingProductTileSkeleton";

const NUM_TILES_LOGGED_OUT = 8;

export const ProductsGridSkeletonLoggedOut: React.FC = () => {
  return (
    <TileGridLoggedOut>
      {Array.from({ length: NUM_TILES_LOGGED_OUT }).map((_, index) => (
        <LoadingProductTileSkeleton key={index} />
      ))}
    </TileGridLoggedOut>
  );
};

const TileGridLoggedOut = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 50fr));
  grid-gap: ${getSpacing("3x", "1x")};
  width: 100%;

  ${responsiveMediaQueries.tabletAndAbove} {
    grid-template-columns: repeat(3, minmax(0, 25fr));
  }
  ${responsiveMediaQueries.desktopAndAbove} {
    grid-template-columns: repeat(4, minmax(0, 33.33fr));
  }
`;
